module.exports = __webpack_public_path__ + "img/demo.8965b17b.svg";